import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSidebar } from '../context/SidebarContext';
import Sidebar from './Sidebar';
import { HiMenuAlt2 } from 'react-icons/hi';

export default function Layout() {
  const { user, loading } = useAuth();
  const { toggle } = useSidebar();

  if (loading) {
    return (
      <div className="min-h-screen bg-dark-700 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gold-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-screen bg-dark-700">
      <Sidebar />
      <div className="flex-1 flex flex-col min-h-screen lg:ml-0">
        {/* Mobile Header - Always rendered, hidden on lg screens via CSS */}
        <header className="sticky top-0 z-30 bg-dark-600 border-b border-dark-400 px-4 py-3 lg:hidden">
          <div className="flex items-center gap-3">
            <button
              onClick={toggle}
              className="p-2 text-gray-400 hover:text-white hover:bg-dark-500 rounded-lg transition-colors"
              aria-label="Open menu"
            >
              <HiMenuAlt2 className="w-6 h-6" />
            </button>
            <div className="flex items-center gap-2">
              <img src="/logo.svg" alt="KG Luxury" className="w-8 h-8" />
              <span className="font-display font-bold gold-gradient-text">KG Luxury</span>
            </div>
          </div>
        </header>
        <main className="flex-1 p-4 md:p-6 lg:p-8 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
